import { SAVE_STORE_FAILURE, SAVE_STORE_REQUEST, SAVE_STORE_SUCCESS, SAVE_STORE_RESET } from "../../actions";
const initialState = {
    saveData: null,
    isLoading: false,
    error: null,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_STORE_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null });
        case SAVE_STORE_SUCCESS:
            return Object.assign(Object.assign({}, state), { saveData: action.payload, isLoading: false, error: null });
        case SAVE_STORE_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case SAVE_STORE_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case SAVE_STORE_RESET:
            return Object.assign({}, initialState);
        default:
            return state;
    }
};
export default reducer;
